import { gql } from "@apollo/client";

export const GET_ESTADOS_CREDITICIO = gql`
    query AllEstadoCrediticio{
        allEstadoCrediticio{
            idEstadoCrediticio
            descripcion
            abreviacion  
        }
    }
`;